// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1MF12","container":"styles_container__2Kq5_","createType":"styles_createType__3u9RV","submitModal":"styles_submitModal__2F8OU"};